import { PropertyCardCustom } from '../components/PropertyCard';
import { CarouselItem } from '../components/template/ImageCarousel';
import ContentManagementInterface, { ImageCarouselType } from './ContentManagementInterface';
import FundOpportunity from './FundOpportunity';
import Investor, { currentInvestment, currentInvestmentLabel } from './Investor';

export default class FundOpportunityCardData implements PropertyCardCustom {
  _fundLeadOpportunity: FundOpportunity;
  private _content: ContentManagementInterface | null | undefined;
  private _contentLoaded: boolean;
  private _investor: Investor;

  constructor(
    fundOpportunity: FundOpportunity,
    investor: Investor,
    contentLoaded: boolean,
    content?: ContentManagementInterface | null,
  ) {
    this._fundLeadOpportunity = fundOpportunity;
    this._content = content;
    this._contentLoaded = contentLoaded;
    this._investor = investor;
  }

  get fundOpportunity() {
    return this._fundLeadOpportunity;
  }

  get investment() {
    return currentInvestment(this._investor) || undefined;
  }

  get investmentLabel() {
    return currentInvestmentLabel(this._investor) || undefined;
  }

  get title() {
    return this._fundLeadOpportunity?.name || 'Coming Soon';
  }

  get fundOpportunityId() {
    return this._fundLeadOpportunity.id;
  }

  get imageDataLoaded(): boolean {
    return this._contentLoaded;
  }

  get altText(): string | undefined {
    if (!this._content) {
      return undefined;
    }

    const summaryItem = this.summaryImageCardItem();

    if (summaryItem) {
      return summaryItem?.altText?.content;
    }

    return 'Coming Soon';
  }

  get image(): PropertyCardCustom['imageUrl'] {
    const summaryItem = this.summaryImageCardItem();

    if (summaryItem) {
      return summaryItem?.imageUrl?.url;
    }

    return '/assets/coming_soon.jpg';
  }

  private summaryImageCardItem(): CarouselItem | undefined {
    if (!this._content) {
      return undefined;
    }

    let summaryItem: CarouselItem | undefined = undefined;

    this._content?.content.find((contentItem) => {
      if (contentItem.type === 'ImageCarousel') {
        return (contentItem as ImageCarouselType).properties.items.find(
          (contentItem: CarouselItem) => {
            if (contentItem.summaryImage) {
              summaryItem = contentItem;
              return true;
            }
          },
        );
      }
    });

    return summaryItem;
  }

  get description(): string | undefined {
    const summaryItem = this.summaryImageCardItem();

    return summaryItem?.text?.content?.replace(/\[footnote:\d+\]/, '');
  }

  get hasContent() {
    return !!this._content;
  }

  get props(): PropertyCardCustom {
    return {
      imageUrl: this.image,
      title: this.title,
      altText: this.altText || this.title,
      description: this.description,
      investment: this.investment,
      investmentLabel: this.investmentLabel,
    };
  }
}
